import { Injectable } from '@angular/core';
// import { ApiService } from '../home/_service/api.service';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Router } from '@angular/router';
import { of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { MetaService } from '@ngx-meta/core';
import { ApiService } from '../_services/api.service';
import { LocalizeRouterService } from 'localize-router';
import { TranslateService } from '@ngx-translate/core';
import { SearchSchede } from './card-list.resolver';

@Injectable()
export class InformazioniResolver implements Resolve<any> {

  constructor(
    private apiService: ApiService,
    private localize: LocalizeRouterService,
    private translate: TranslateService,
    private router: Router,
    private meta: MetaService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log('InformazioniResolver -> ', this.translate.currentLang, ', ', route.params.slug, ', ', JSON.stringify(route.queryParams));
    const language = this.translate.currentLang.toUpperCase();

    const jsonIn = {
      slug: route.params.slug,
      cdLingua: this.translate.currentLang.toUpperCase(),
      anteprima: (route.queryParams.anteprima === 'true' ? true : false)
    };

    return this.apiService.getPagina(jsonIn).pipe(
      map(pagina => {

        if (!pagina || !pagina.idPagina) { this.router.navigate([this.localize.translateRoute('/404')]); }
        if ( pagina.stato !== 1 && !jsonIn.anteprima) { this.router.navigate([this.localize.translateRoute('/404')]); }

        if (pagina.seo[language].slug !== route.params.slug) {
          this.localize.parser.translateRoutes(this.translate.currentLang).subscribe(() => {
            const base = this.localize.translateRoute('/informazioni');
            this.router.navigate([base, pagina.seo[language].slug]);
          });
        }

        if (pagina.seo) {
          if (pagina.seo[language].title) {
            this.meta.setTitle(pagina.seo[language].title);
          }
          if (pagina.seo[language].description) {
            this.meta.setTag('description', pagina.seo[language].description);
          }
          if (pagina.seo[language].keywords) {
            this.meta.setTag('keywords', pagina.seo[language].keywords);
          }
          if (pagina.seo[language].noIndex) {
            this.meta.setTag('robots', 'noindex');
          }
        }

        if (pagina.modello === 'Tab' && pagina.blocchi.length > 0) {
          pagina.blocchi[0].feSelected = true;
        }
        if (pagina.blocchi) {
          pagina.blocchi = pagina.blocchi.sort((b1, b2) => b1.ordine - b2.ordine);
        }
        
        return({pagina});
      })
    );
  }

}
